import { useEffect, useState } from "react";

export default function TenantTable({
  tenants,
  documents,
  selectedFiles,
  onEdit,
  onDelete,
  onFileChange,
  onUpload,
  onDeleteDoc,
}) {
  const [openTenantId, setOpenTenantId] = useState(null);

  const openTenant = tenants.find((tenant) => tenant.id === openTenantId);
  const openTenantDocuments = openTenant ? documents[openTenant.id] || [] : [];

  useEffect(() => {
    if (openTenantId === null) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpenTenantId(null);
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [openTenantId]);

  if (!tenants.length) return <p className="admin-empty-state">No tenants found.</p>;

  return (
    <>
      <div className="admin-table-wrap">
      <table className="admin-table admin-tenant-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Documents</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {tenants.map((tenant) => (
            <tr key={tenant.id}>
              <td>{tenant.name}</td>
              <td>{tenant.email}</td>

              <td>
                <div className="admin-upload-controls">
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => onFileChange(tenant.id, e.target.files[0])}
                  />

                  <button className="admin-button admin-button-primary" type="button" onClick={() => onUpload(tenant.id)}>
                    Upload PDF
                  </button>

                  {(documents[tenant.id] || []).length > 0 && (
                    <button
                      className="admin-button admin-button-secondary"
                      type="button"
                      onClick={() => setOpenTenantId(tenant.id)}
                    >
                      View files
                      <span className="admin-file-count">{documents[tenant.id].length}</span>
                    </button>
                  )}
                </div>
              </td>

              <td>
                <div className="admin-row-actions">
                  <button className="admin-button admin-button-secondary" type="button" onClick={() => onEdit(tenant)}>
                    Edit
                  </button>

                  <button
                    className="admin-button admin-button-danger"
                    type="button"
                    onClick={() => {
                      if (window.confirm("Delete tenant?")) {
                        onDelete(tenant.id);
                      }
                    }}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>

      {openTenant && (
        <div
          className="admin-modal-backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setOpenTenantId(null);
          }}
        >
          <section
            className="admin-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="tenant-files-title"
          >
            <div className="admin-modal-header">
              <div>
                <p className="admin-page-eyebrow">Tenant documents</p>
                <h2 id="tenant-files-title">{openTenant.name}</h2>
                <p>{openTenantDocuments.length} {openTenantDocuments.length === 1 ? "file" : "files"} uploaded</p>
              </div>
              <button
                className="admin-modal-close"
                type="button"
                aria-label="Close tenant files"
                onClick={() => setOpenTenantId(null)}
                autoFocus
              >
                &times;
              </button>
            </div>

            <div className="admin-modal-body">
              {!openTenantDocuments.length ? (
                <p className="admin-empty-state">No files have been added for this tenant.</p>
              ) : (
                <ul className="admin-modal-file-list">
                  {openTenantDocuments.map((doc) => (
                    <li key={doc.id}>
                      <div className="admin-modal-file-details">
                        <span className="admin-file-icon" aria-hidden="true">PDF</span>
                        <div>
                          <strong>{doc.name}</strong>
                          <span>Tenant document</span>
                        </div>
                      </div>
                      <div className="admin-row-actions">
                        <a
                          className="admin-button admin-button-secondary"
                          href={`${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/documents/${doc.id}/download`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Open
                        </a>
                        <button
                          className="admin-button admin-button-danger"
                          type="button"
                          onClick={() => onDeleteDoc(doc.id, openTenant.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="admin-modal-footer">
              <button
                className="admin-button admin-button-secondary"
                type="button"
                onClick={() => setOpenTenantId(null)}
              >
                Close
              </button>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
